/* eslint-disable import/prefer-default-export */

import {
  getAprooverFilters,
  getInspectorFilters
} from '../../components/WeeklyReportTable/utils/consts';
import { isoFromDate, todayIso } from '../../components/WeeklyReportTable/utils/date';
import { getSavedFilters } from '../../services/userFilterServices';
import { formatFilterToComboOption } from '../../utils/formatUtils';

/**
 * @param {import('../../components/WeeklyReportTable/hooks/useFilters').Filters} filters
 * @returns {import('../../services/workReport').WeeklyReportFilters}
 */
export const filtersAdapter = (filters, isInspector) => ({
  contratosIds: filters.contratosIds?.map((contract) => contract.id),
  partesVisualizar: filters.partesVisualizar,
  equiposIds: filters.idsEquipos?.map((equipment) => equipment.value),
  eventosIds: filters.idsEventos?.map((event) => event.value),
  proveedoresIds: filters.idsProveedores?.map((provider) => provider.id),
  posicionesLineas: filters.posicionesLineas?.map((positionLine) => positionLine?.value),
  serviciosIds: filters.serviciosIds?.map((service) => service.id),
  tipoUbicacionId: filters.tipoUbicacionId?.id || null,
  ubicacionesIds: filters.ubicacionesIds?.map((location) => location?.id),
  desde: filters?.fechaDesde,
  hasta: filters?.fechaHasta,
  ...(isInspector
    ? { grupoEstadoParteId: filters.estadoParteId?.id || null }
    : { estadoParteId: filters.estadoParteId?.id || null })
});

export const filtersAdapterToSave = (filters, isInspector) => {
  const getNameAndId = (filter) => ({
    id: filter.id,
    nombre: filter.nombre
  });

  const partStateIdName = isInspector ? 'grupoEstadoParteId' : 'estadoParteId';

  return {
    TipoFiltroUsuario: isInspector ? getInspectorFilters : getAprooverFilters,
    filtros: JSON.stringify({
      contratosIds: filters.contratosIds?.map((contract) => getNameAndId(contract)),
      partesVisualizar: filters.partesVisualizar,
      equiposIds: filters.idsEquipos?.map((equipment) => getNameAndId(equipment)),
      eventosIds: filters.idsEventos?.map((event) => getNameAndId(event)),
      proveedoresIds: filters.idsProveedores?.map((provider) => getNameAndId(provider)),
      posicionesLineas: filters.posicionesLineas?.map((positionLine) => positionLine?.value),
      serviciosIds: filters.serviciosIds?.map((service) => getNameAndId(service)),
      tipoUbicacionId: filters.tipoUbicacionId
        ? { nombre: filters.tipoUbicacionId.nombre, id: filters.tipoUbicacionId.id }
        : null,
      ubicacionesIds: filters.ubicacionesIds?.map((location) => getNameAndId(location)),
      [partStateIdName]: filters.estadoParteId
        ? { nombre: filters.estadoParteId.nombre, id: filters.estadoParteId.id }
        : null,
      fechaDesde: filters?.fechaDesde,
      fechaHasta: filters?.fechaHasta
    })
  };
};

export const getSavedFiltersAdapter = async (isInspector) => {
  try {
    const userType = isInspector ? getInspectorFilters : getAprooverFilters;

    const { filtros } = await getSavedFilters(userType);
    const savedFilters = JSON.parse(filtros);

    return {
      contratosIds: formatFilterToComboOption(savedFilters.contratosIds) || [],
      partesVisualizar: savedFilters.partesVisualizar,
      idsEquipos: formatFilterToComboOption(savedFilters.equiposIds) || [],
      idsEventos: formatFilterToComboOption(savedFilters.eventosIds) || [],
      idsProveedores: formatFilterToComboOption(savedFilters.proveedoresIds) || [],
      posicionesLineas: savedFilters.posicionesLineas.map((e) => {
        const [position, line] = e.split('-');

        return {
          label: `P${position} - L${line}`,
          value: e
        };
      }),
      tipoUbicacionId: formatFilterToComboOption(savedFilters.tipoUbicacionId) || null,
      ubicacionesIds: formatFilterToComboOption(savedFilters.ubicacionesIds) || [],
      serviciosIds: formatFilterToComboOption(savedFilters.serviciosIds) || [],
      estadoParteId:
        formatFilterToComboOption(
          isInspector ? savedFilters.grupoEstadoParteId : savedFilters.estadoParteId
        ) || null,
      fechaDesde: savedFilters.fechaDesde || isoFromDate,
      fechaHasta: savedFilters.fechaHasta || todayIso
    };
  } catch {
    return null;
  }
};
